module.exports = __webpack_public_path__ + "static/media/gallery-videos.111cb8c3.svg";